import { useMutation, useQueryClient } from '@tanstack/react-query';
import { shopifyApi } from 'services';

export const useDisconnectShopify = () => {
  const queryClient = useQueryClient();

  const disconnectMutation = useMutation({
    mutationFn: () => shopifyApi.disconnectStore(),
    onSuccess: () => {
      // Invalidate connection status to refetch
      queryClient.invalidateQueries({ queryKey: ['shopify', 'connection-status'] });
    },
  });

  return {
    disconnectShopify: disconnectMutation.mutateAsync,
    isDisconnecting: disconnectMutation.isPending,
    disconnectionError: disconnectMutation.error,
  };
};